import { CheckCircle2, CircleAlert, CircleMinus, X } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

const ST = { ok: [CheckCircle2, "text-emerald-600"], partial: [CircleAlert, "text-amber-600"], missing: [CircleMinus, "text-slate-400"] };

export function MaterialsList({ items, testid = "materials-report" }) {
  return (
    <ul className="space-y-1" data-testid={testid}>
      {items.map((m) => {
        const [Icon, cls] = ST[m.status] || ST.missing;
        return (
          <li key={m.key} className="flex items-start gap-1.5" data-testid={`${testid}-${m.key}`}>
            <Icon size={13} className={`mt-0.5 shrink-0 ${cls}`} />
            <span className="min-w-0 break-words"><b className="font-medium text-slate-800">{m.label}</b>{m.detail ? <span className="text-slate-500"> · {m.detail}</span> : null}</span>
          </li>
        );
      })}
    </ul>
  );
}

export default function ScrapedBox({ data, onRemove, authorized, onAuthorize }) {
  const deep = data.version === 2;
  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50/60 p-4 text-xs text-slate-700 space-y-2" data-testid="scraped-box">
      <div className="flex items-center justify-between gap-2">
        <p className="flex items-center gap-1.5 font-semibold text-emerald-800"><CheckCircle2 size={14} />{deep ? `Sito analizzato: ${data.pages?.length || 1} pagine (informazioni reali pubbliche)` : "Dati recuperati dal sito (informazioni reali pubbliche)"}</p>
        <button onClick={onRemove} aria-label="Rimuovi" data-testid="scraped-remove-btn"><X size={14} /></button>
      </div>
      <p><span className="text-slate-500">Titolo:</span> {data.title || "—"}</p>
      {data.nav?.length > 0 && <p className="line-clamp-2"><span className="text-slate-500">Menu:</span> {data.nav.slice(0, 10).join(" · ")}</p>}
      {deep && data.materials?.length > 0 && <MaterialsList items={data.materials} />}
      {deep && (
        <label className="flex items-start gap-2 rounded-md bg-white/70 border border-emerald-200 p-2.5 text-slate-800 cursor-pointer" data-testid="client-images-auth">
          <Checkbox checked={!!authorized} onCheckedChange={(v) => onAuthorize(!!v)} className="mt-0.5" data-testid="client-images-auth-checkbox" />
          <span>Il cliente autorizza l'uso delle foto e del logo del suo sito <span className="block text-[11px] text-slate-500">Se non spunti, la demo usa solo foto di stock e il logo caricato da te.</span></span>
        </label>
      )}
      <p className="text-slate-500">L'AI userà solo questi dati come reali: quello che manca non verrà inventato e sarà indicato nel report finale.</p>
    </div>
  );
}
